module.exports = __webpack_public_path__ + "static/img/bg.cb37df4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/bg.png
// module id = yM6R
// module chunks = 1